export const decimalToHex = d => {
  const hex = Number(d).toString(16);
  return hex.length < 2 ? '0' + hex : hex;
};
